<script setup lang="ts">
import { computed } from 'vue'

import type { Paragraph } from '../../../../services/rendering-nxt/src/utils/content-block-schema/content-blocks'

const props = withDefaults(defineProps<{
  paragraphs?: Paragraph[]
}>(), {
  paragraphs: () => []
})

const heading = computed(() => {
  const headingParagraph = props.paragraphs.find(
    (p): p is Extract<Paragraph, { paragraphType: 'heading' }> =>
      p.paragraphType === 'heading'
  )
  const interlineParagraph = props.paragraphs.find(
    (p): p is Extract<Paragraph, { paragraphType: 'interline' }> =>
      p.paragraphType === 'interline'
  )
  return headingParagraph?.heading.text ?? interlineParagraph?.interline?.text ?? ''
})

const text = computed(() => {
  const textParagraph = props.paragraphs.find(
    (p): p is Extract<Paragraph, { paragraphType: 'text' }> =>
      p.paragraphType === 'text'
  )
  return textParagraph?.text ?? ''
})
</script>

<template>
  <div v-if="heading || text"
       class="md:pt-4">
    <h2 v-if="heading"
        class="pt-4 pb-6 gap-[10px] font-heading text-heading-sm md:text-heading-lg">
      {{ heading }}
    </h2>
    <div v-if="text"
         class="pt-0 pb-8 gap-[10px] font-body text-body-md md:text-body-lg prose prose-a:text-secondary-500 hover:prose-a:text-primary-350 prose-a:decoration-from-font prose-a:underline-offset-2 prose-p:m-0 prose-li:m-0 prose-li:leading-7 prose-li:ps-0 sm:prose-li:leading-8 prose-li:marker:text-foreground [&_u]:decoration-from-font [&_u]:underline-offset-2 [&_li_p]:m-0"
         v-html="text" />
    <slot />
  </div>
</template>
